import React from "react";
import { Button } from "antd";

import Frequency from "../Frequency";

class CommunitySection extends React.Component {
  constructor() {
    super();
    this.state = { visibleSplitting: false };
  }

  toggleSplitting = () => {
    this.setState({
      visibleSplitting: !this.state.visibleSplitting
    });
  };

  render() {
    const { item } = this.props;
    const { visibleSplitting } = this.state;
    return (
      <div className="community__section">
        <div className="community__row">
          <div className="community__cell">
            <div className="community__group">
              <Button
                className="community__toggle ant-btn-icon-only"
                onClick={this.toggleSplitting}
              >
                <img
                  src={
                    visibleSplitting
                      ? "/img/minus-blue.svg"
                      : "/img/plus-blue.svg"
                  }
                  width="11"
                  alt=""
                />
              </Button>
              <div className="community__name">{item.title}</div>
            </div>
          </div>
          <div className="community__cell">{item.variantAllele}</div>
          <div className="community__cell">{item.homozygotes}</div>
          <div className="community__cell">{item.frequency + "%"}</div>
          <div className="community__cell">
            <div className="community__slider">
              <div
                className="community__percent"
                style={{ width: item.alleleFrequencyLog + "%" }}
              />
            </div>
          </div>
        </div>
        {visibleSplitting && (
          <div className="community__splitting">
            {item.splitting.map((x, i) => (
              <div className="community__row" key={i}>
                <div className="community__cell">
                  <div className="community__group">{x.title}</div>
                </div>
                <div className="community__cell">{x.variantAllele}</div>
                <div className="community__cell">{x.homozygotes}</div>
                <div className="community__cell">{x.frequency}</div>
                <div className="community__cell">
                  <div className="community__slider">
                    <div
                      className="community__percent"
                      style={{ width: x.alleleFrequencyLog + "%" }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        <div className="community__scale">
          <Frequency value={item.maxRecessive} />
        </div>
      </div>
    );
  }
}

export default CommunitySection;
